.timing {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-4);
  margin-top: var(--tuna-spacing-3);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
}

/*
 * The caveat that says what the chips are measured against. Muted rather than a headline: it is a
 * standing condition of the reading, not a verdict on the take.
 */
.caveat {
  margin: 0;
  color: var(--tuna-content-muted);
  font-size: var(--tuna-typography-body2-fontSize);
  line-height: 1.5;
}

.body {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  line-height: 1.5;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.chip {
  display: flex;
  align-items: baseline;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  font-size: var(--tuna-typography-body2-fontSize);
}

.chipIndex {
  color: var(--tuna-content-muted);
  font-variant-numeric: tabular-nums;
}

.chipBand {
  font-weight: 700;
}
